import { SOURCE_SYSTEMS, normalizeSourceSystem } from '@process-advisor/process-miner/sources/capabilities';

export const JIRA_FIELD_PROFILE = Object.freeze({
  sourceSystem: SOURCE_SYSTEMS.JIRA,
  identityFields: ['key', 'summary'],
  contextFields: ['issue_type', 'priority', 'project', 'assignee', 'reporter', 'components', 'labels'],
  timingFields: ['created', 'updated', 'resolutiondate'],
  segmentationPriority: [
    'priority',
    'issue_type',
    'issuetype',
    'project',
    'components',
    'component',
    'assignee',
    'reporter',
    'labels',
    'fix_versions',
    'fixVersions',
    'status',
    'resolution',
  ],
});

export const SERVICE_NOW_FIELD_PROFILE = Object.freeze({
  sourceSystem: SOURCE_SYSTEMS.SERVICENOW,
  identityFields: ['number', 'short_description', 'sys_id'],
  defaultContextFields: ['priority', 'assignment_group'],
  optionalContextFields: ['impact', 'urgency', 'category', 'subcategory', 'contact_type', 'business_service', 'service_offering', 'cmdb_ci', 'company', 'location', 'caller_id', 'requested_for', 'approval', 'close_code', 'resolution_code', 'made_sla'],
  timingFields: ['opened_at', 'resolved_at', 'closed_at', 'business_duration', 'calendar_duration'],
  segmentationPriority: [
    'priority',
    'assignment_group',
    'impact',
    'urgency',
    'category',
    'subcategory',
    'contact_type',
    'business_service',
    'service_offering',
    'cmdb_ci',
    'close_code',
    'resolution_code',
    'made_sla',
    'company',
    'location',
  ],
});

export const GENERIC_FIELD_PROFILE = Object.freeze({
  sourceSystem: SOURCE_SYSTEMS.GENERIC,
  identityFields: ['task', 'summary'],
  contextFields: [],
  timingFields: [],
  segmentationPriority: [],
});

export function getFieldProfileForSource(sourceSystem) {
  switch (normalizeSourceSystem(sourceSystem)) {
    case SOURCE_SYSTEMS.SERVICENOW:
      return SERVICE_NOW_FIELD_PROFILE;
    case SOURCE_SYSTEMS.JIRA:
      return JIRA_FIELD_PROFILE;
    default:
      return GENERIC_FIELD_PROFILE;
  }
}

export function getSegmentAttributePriorityForSource(sourceSystem) {
  const profile = getFieldProfileForSource(sourceSystem);
  return Array.isArray(profile?.segmentationPriority) ? profile.segmentationPriority : [];
}
